import Navigate             from "Dashboard/Core/Navigate";
import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { Court }            from "Utils/API";



// The initial State
const initialState = {
    loading    : true,
    error      : false,
    edition    : 0,
    canCreate  : false,
    canEdit    : false,
    canFilter  : false,
    canImport  : false,
    canExport  : false,
    list       : [],
    total      : 0,
    elem       : {},
    activityID : 0,
    activities : [],
    statuses   : [],
    sort       : {
        orderBy  : "fullName",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "COURT_LOADING" });
    },

    /**
     * Fetches the Court List
     * @param {Function} dispatch
     * @param {String=}  type
     * @param {Number=}  elemID
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, type = "", elemID = 0, params = {}) {
        Navigate.unsetParams(params);
        if (type === "RESERVE_TYPE") {
            params.reserveTypeID = elemID;
        }

        const data = await Court.getAll(params);
        data.sort = params;
        dispatch({ type : "COURT_LIST", data });
    },

    /**
     * Fetches a single Court
     * @param {Function} dispatch
     * @param {Number}   courtID
     * @returns {Promise}
     */
    async fetchElem(dispatch, courtID) {
        const data = await Court.getOne({ courtID });
        dispatch({ type : "COURT_ELEM", data });
    },

    /**
     * Fetches the Court Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await Court.getEditData();
        dispatch({ type : "COURT_EDIT", data });
    },

    /**
     * Edits/Creates a Court
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return Court.edit(data);
    },

    /**
     * Deletes a Court
     * @param {Function} dispatch
     * @param {Number}   courtID
     * @returns {Promise}
     */
    deleteElem(dispatch, courtID) {
        return Court.delete({ courtID });
    },
};



/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "COURT_LIST", "COURT_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "COURT_LOADING":
        return {
            ...state,
            loading    : true,
        };

    case "COURT_LIST":
        return {
            ...state,
            loading    : false,
            error      : false,
            canCreate  : action.data.canCreate,
            canEdit    : action.data.canEdit,
            canFilter  : action.data.canFilter,
            canImport  : action.data.canImport,
            canExport  : action.data.canExport,
            list       : action.data.list,
            activityID : action.data.activityID,
            total      : action.data.total,
            sort       : action.data.sort,
        };

    case "COURT_ELEM":
        return {
            ...state,
            error      : false,
            edition    : state.edition + 1,
            elem       : action.data.elem,
            activities : action.data.activities,
            statuses   : action.data.statuses,
        };

    case "COURT_EDIT":
        return {
            ...state,
            error      : false,
            edition    : state.edition + 1,
            activities : action.data.activities,
            statuses   : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
